import { createContext, useContext } from "react";

import type { TrackedRunTarget, WorkflowRunTrackerValue } from "./types";

export const WorkflowRunTrackerContext = createContext<WorkflowRunTrackerValue | null>(null);

/**
 * The tracker, or `null` when no provider is mounted.
 *
 * Optional on purpose: tables and dialogs render in tests and in Storybook
 * without the app root, and a workflow surface that silently falls back to its
 * previous behaviour is far better than one that throws in a story.
 */
export const useWorkflowRunTrackerOptional = (): WorkflowRunTrackerValue | null =>
  useContext(WorkflowRunTrackerContext);

/**
 * The pk a workflow just created in this collection, for the post-run row flash.
 * Returns `undefined` when nothing settled here — or when no provider is mounted.
 */
export const useSettledRunPk = (target: TrackedRunTarget | undefined): string | undefined => {
  const tracker = useWorkflowRunTrackerOptional();

  return target ? tracker?.settledPkFor(target) : undefined;
};
